import React from 'react';

const colors = ['#3A56E8', '#42b9c0', '#D3A300', '#0EA968'];

const ButtonBet = ({ color, t }: any) => {
  const mainColor = colors[color % 4] || '#D3A300';
  return (
    <div className='pt-3 hover:brightness-90'>
      <div className='relative flex h-[54px] w-[149px] items-center justify-center'>
        <div className='cursor-hand absolute -right-[12px] top-0 -scale-x-100'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='32'
            height='55'
            viewBox='0 0 32 55'
            fill='none'
          >
            <path
              d='M25.5 -3.99994L4.99951 27.3797L28 61.5001'
              stroke={mainColor}
              strokeOpacity='0.5'
              strokeWidth='8'
            />
          </svg>
        </div>
        <div className='cursor-hand absolute -right-[21px] top-0 -scale-x-100 animate-pulse'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='30'
            height='55'
            viewBox='0 0 30 55'
            fill='none'
          >
            <path
              d='M24.5 -3.99994L3.99951 27.3797L27 61.5001'
              stroke={mainColor}
              strokeOpacity='0.3'
              strokeWidth='6'
            />
          </svg>
        </div>
        <div className='cursor-hand absolute left-0 top-0'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='150'
            height='55'
            viewBox='0 0 150 55'
            fill='none'
          >
            <path
              d='M16.7451 1.29914C17.113 0.726148 17.7472 0.3797 18.4281 0.3797H131.199C131.873 0.3797 132.502 0.718977 132.871 1.28228L149.28 26.2823C149.717 26.9485 149.717 27.8109 149.28 28.4771L132.871 53.4771C132.502 54.0404 131.873 54.3797 131.199 54.3797H19.3949C18.7322 54.3797 18.1126 54.0515 17.7403 53.5033L0.742037 28.4724C0.291988 27.8097 0.280807 26.9423 0.713618 26.2682L16.7451 1.29914Z'
              fill={mainColor}
            />
          </svg>
        </div>
        <div className='cursor-hand absolute -left-[11px] top-0'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='32'
            height='55'
            viewBox='0 0 32 55'
            fill='none'
          >
            <path
              d='M25.5 -3.99994L4.99951 27.3797L28 61.5001'
              stroke={mainColor}
              strokeOpacity='0.5'
              strokeWidth='8'
            />
          </svg>
        </div>
        <div className='cursor-hand absolute -left-[20px] top-0 animate-pulse'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='30'
            height='55'
            viewBox='0 0 30 55'
            fill='none'
          >
            <path
              d='M24.5 -3.99994L3.99951 27.3797L27 61.5001'
              stroke={mainColor}
              strokeOpacity='0.3'
              strokeWidth='6'
            />
          </svg>
        </div>
        <div className='cursor-hand text-24 relative font-bold text-white'>
          {t('mainSlider.betBtn')}
        </div>
      </div>
    </div>
  );
};

export default ButtonBet;
